import { CheckCircleOutlined, ClockCircleOutlined, ExclamationCircleOutlined, CloseCircleOutlined, SyncOutlined, MinusCircleOutlined } from '@ant-design/icons';

export const useStatusRender = () => {
  return (status: string) => {
    switch (status) {
      case 'PENDING':
        return {
          icon: <ClockCircleOutlined />,
          text: 'Pending',
          color: '#faad14',
          bgColor: '#fff7e6',
          textColor: '#d48806',
          borderColor: '#ffd666',
        };
      case 'SCHEDULED':
        return {
          icon: <ClockCircleOutlined />,
          text: 'Scheduled',
          color: '#1890ff',
          bgColor: '#e6f7ff',
          textColor: '#096dd9',
          borderColor: '#91d5ff',
        };
      case 'RESCHEDULED':
        return {
          icon: <SyncOutlined />,
          text: 'Rescheduled',
          color: '#722ed1',
          bgColor: '#f9f0ff',
          textColor: '#531dab',
          borderColor: '#d3adf7',
        };
      case 'COMPLETED':
        return {
          icon: <CheckCircleOutlined />,
          text: 'Completed',
          color: '#52c41a',
          bgColor: '#f6ffed',
          textColor: '#389e0d',
          borderColor: '#b7eb8f',
        };
      case 'CANCELLED':
        return {
          icon: <CloseCircleOutlined />,
          text: 'Cancelled',
          color: '#ff4d4f',
          bgColor: '#fff2f0',
          textColor: '#cf1322',
          borderColor: '#ffb3b3',
        };
      case 'NO_SHOW':
        return {
          icon: <MinusCircleOutlined />,
          text: 'No Show',
          color: '#8c8c8c',
          bgColor: '#f5f5f5',
          textColor: '#595959',
          borderColor: '#d9d9d9',
        };
      default:
        return {
          icon: <ExclamationCircleOutlined />,
          text: status || 'Unknown',
          color: '#d9d9d9',
          bgColor: '#fafafa',
          textColor: '#8c8c8c',
          borderColor: '#d9d9d9',
        };
    }
  };
};